import {Route} from '@angular/router';
import {StartPageComponent} from "./start-page.component";

export const startPageRoutes: Route[] = [
  {
    path: '',
    component: StartPageComponent,
  }
];
